<div class="modal-header">
	<h5 class="modal-title">Confirmar e-mail</h5>
</div>
<div class="modal-body">
	<p>Confirme se este é seu e-mail correto:</p>
	<p class="fw-medium text-dark">{{ email }}</p>
</div>
<div class="modal-footer">
	<seira-public-button footer (click)="declinar()">
		Corrigir
	</seira-public-button>
	<seira-public-button footer (click)="confirmar()">
		Confirmar
	</seira-public-button>
</div>
